
import {combineReducers} from "redux";

import {goatReducer as goat} from "./goatReducer"


export default combineReducers({
    goat
})